// src/context/CurrencyContext.js
import React, { createContext, useState, useEffect } from "react";
import { db } from "../firebase-config";
import { doc, onSnapshot } from "firebase/firestore";

export const CurrencyContext = createContext();

export const SURCHARGE_EUR = 0;

export function pricePlusSurcharge(priceEUR, cur, fx) {
  const grossEUR = priceEUR + SURCHARGE_EUR;

  switch (cur) {
    case "USD": {
      const usd = grossEUR * (fx.USD || 1);
      return { numeric: usd, formatted: `$${usd.toFixed(2)}` };
    }
    case "GBP": {
      const gbp = grossEUR * (fx.GBP || 1);
      return { numeric: gbp, formatted: `£${gbp.toFixed(2)}` };
    }
    default:
      return { numeric: grossEUR, formatted: `€${grossEUR.toFixed(2)}` };
  }
}

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("EUR");

  const [exchangeRates, setExchangeRates] = useState({
    EUR: 1,
    USD: 0.92,
    GBP: 0.94,
  });

  useEffect(() => {
    const ratesDocRef = doc(db, "FX", "rates");

    const unsubscribe = onSnapshot(
      ratesDocRef,
      (snap) => {
        if (snap.exists()) {
          const d = snap.data();
          setExchangeRates({
            EUR: 1,
            USD: d.euroToDollar || 0.92,
            GBP: d.euroToPound || 0.94,
          });
        } else {
          console.warn("No FX rates found, using default rates.");
        }
      },
      (err) => console.error("Error fetching FX rates:", err)
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("currency");
    if (["EUR", "USD", "GBP"].includes(saved)) setCurrency(saved);
  }, []);

  const changeCurrency = (next) => {
    if (["EUR", "USD", "GBP"].includes(next)) {
      setCurrency(next);
      localStorage.setItem("currency", next);
    }
  };

  return (
    <CurrencyContext.Provider
      value={{ currency, exchangeRates, changeCurrency }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
